import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

export const getCDocFolderList = (item) => {
    let url = `${API.CDocFolderList}?FolderName=${item.FolderName}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getCDocFolderListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getCDocFolderListFailure",
                    error: "ERROR"
                })
            })
    }
};

export const getCDocFilesList = (input) => {
    let url = `${API.CDocUrl}${input.FolderId}/file?FileName=${input.FileName}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getCDocFileListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getCDocFileListFailure",
                    error: "ERROR"
                })
            })
    }
};

export const postCDocAttachment = (postItem) => {
    const data = new FormData();
    data.append("file", postItem);

    let url = `${API.AttachmentAPI}`;
    return (dispatch) => {
        axios
            .post(url, data)
            .then((response) => {
                dispatch({
                    type: "postCDocAttachmentUploadSuccess",
                    data: response.data,
                });
            })
            .catch((error) => {
                dispatch({
                    type: "postCDocAttachmentUploadFailure",
                    error: "ERROR",
                });
            });
    };
};

export const postFolder = (data, history,t) => {
    
    let url = `${API.CDocFolderPost}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                if (response.data) {
                    let searchData = {
                        FolderName: "",
                        PageNumber: 1,
                        PageSize: 20
                    }
                    dispatch(getCDocFolderList(searchData));
                    history.push("/Home/ControlledDocuments")
                    toast.success(t('CommonText.CommonAdd'), {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                dispatch({ type: "ShowSidePan", data: false });
            })
            .catch((error) => {
                dispatch({
                    type: "postCDocFolderFailure",
                    error: "ERROR"
                })
            })
    }
};

export const postCDocFile = (id, data, history,t) => {
    let url = `${API.CDocUrl}${id}/file`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                if (response.data) {
                    dispatch(getCDocFilesList(id));
                    history.push(`/Home/ControlledDocumentsView/${id}/Files`);
                    toast.success(t('CommonText.CommonAdd'), {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                dispatch({ type: "ShowSidePan", data: false });
            })
            .catch((error) => {
                // console.log(error);
            })
    }
};

export const deleteCDocFolder = (item) => {
    let url = `${API.CDocUrl}${item.folderId}`;
    return (dispatch) => {
        axios
            .delete(url)
            .then((response) => {
                let searchData = {
                    FolderName: "",
                    PageNumber: 1,
                    PageSize: 20
                }
                dispatch({
                    type: "deleteFolderSuccess",
                    data: response.data,
                });
                dispatch(getCDocFolderList(searchData));
                toast.success("Deleted Successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
            .catch((error) => {
                dispatch({
                    type: "deleteFolderFailure",
                    error: "ERROR",
                });
            });
    };
};

export const deleteCDocFile = (id, item, input) => {
    let url = `${API.CDocUrl}${id}/file/${item.fileId}`;
    return (dispatch) => {
        axios
            .delete(url)
            .then((response) => {
                dispatch({
                    type: "deleteNoteSuccess",
                    data: response.data,
                });
                let input= {
                    FolderId : id,
                    FileName: "",
                    PageNumber: 1,
                    PageSize: 20
                }
                dispatch(getCDocFilesList(input));
                toast.success("Deleted Successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
            .catch((error) => {
                dispatch({
                    type: "deleteFolderFailure",
                    error: "ERROR",
                });
            });
    };
};
